import React, { Component } from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Header from "../../Header/Header";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";

class WinnersStory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawtype: 10,
            pastDrawShow: [],
            currentPageNo: 0,
            NumberofRecord: 6,
            totalPage: 0,
            startinx: 0,
            endinx: 6,
            lfilterdt: [],
            IsValidData: false,
            _dbdrawType: 10

        }
    }

    componentDidMount() {
        this.setjsonvideourl();
        // localStorage.setItem('drawtabId', 3);
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.state.pastDrawShow && this.state.pastDrawShow !== prevProps.pastDrawShow && this.state.pastDrawShow.length != 0 && this.state.IsValidData == false) {
            this.state.IsValidData = true;
            this.setState({ IsValidData: true })
            this.LoadTransactionData()
            // window.allDrawResultPopUp();
        }
    }


    LoadTransactionData = () => {
        if (this.state.pastDrawShow && this.state.pastDrawShow.length > 0) {
            this.setState({ lfilterdt: this.state.pastDrawShow });
            let ltotpage = Math.trunc(this.state.pastDrawShow.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(this.state.pastDrawShow.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }






    setjsonvideourl = () => {
        try {
            let hbanner = 0;
            let hbanner_old = localStorage.getItem('pagevideovr');
            if (this.props.appvariables.bVersion) {
                let hbannerVer = this.props.appvariables.bVersion.split("~")
                if (hbannerVer.length > 0) {
                    hbanner = hbannerVer[4];//[4]
                    localStorage.setItem('pagevideovr', hbanner);
                }
            }
            if (hbanner_old != hbanner) {
                var s = process.env.REACT_APP_CDN_URL + 'web/WinnerVideoUrl.json' + "?V" + hbanner;
                fetch(s).then(response => response.json()).then(data => {
                    localStorage.setItem('pagevideourl', JSON.stringify(data.winnerVideoList));
                    this.setState({ pastDrawShow: data.winnerVideoList })
                    // this.setState({ pastDrawShow: data.winnerVideoList })
                    console.log("data video url", data.winnerVideoList)
                })
            } else {
                let Videourl = JSON.parse(localStorage.getItem('pagevideourl'));
                this.setState({ pastDrawShow: Videourl })
                // this.setState({ pastDrawShow: Videourl })
                console.log("data video url", Videourl)
            }

        }
        catch (ex) {
            console.log("setjsondata => " + ex)
        }
    };


    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }


    render() {
        const { t } = this.props;
        return (

            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : WinnersStory</title>
                    <meta name="description" content="Gulf Ticket WinnersStory" />
                </Helmet>
                }
                <h2 class="headding1 padding-top-0">Our Hero's Story</h2>
                <div class="pastDrawShows">
                    {this.state.pastDrawShow && this.state.pastDrawShow.length > 0 && this.state.pastDrawShow.slice(this.state.startinx, this.state.endinx).map((Obj, inxd) =>
                        <div class="pastDrawShowsLi oursbg">
                            <iframe
                                width="100%"
                                height="auto"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                className="rounded-md"
                                allowFullScreen
                                src={Obj.videoUrl + '&rel=0'}
                                style={{ border: "0px" }}
                            >
                            </iframe>
                            <div class="pastDrawShowDetls">
                                <h4>{Obj.playername}</h4>
                                <div>
                                    <img src="./assets/img/icons/calender-y.png" />
                                    <span>{Obj.date}</span>
                                </div>
                                <div>
                                    <img src="./assets/img/icons/usd.png" />
                                    <span>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(Obj.amount)}</span>
                                </div>
                            </div>
                            {/* <h4 className={`oWTxtClr${Obj.GameTypeId == 1 ? '2' : Obj.GameTypeId == 2 ? '3' : '1'}`}>{Obj.playername}</h4>
                            <p className={`oWTxtClr${Obj.GameTypeId == 1 ? '2' : Obj.GameTypeId == 2 ? '3' : '1'}`}>{Obj.date} of {this.props.appvariables.currency} {commonClass.aedCrnyConvert(Obj.amount)}</p> */}
                        </div>
                    )}


                    <div class="pagination">
                        <div class="paginationLft">
                            {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{this.state.pastDrawShow && Math.ceil(this.state.pastDrawShow.length / this.state.NumberofRecord)}</span> {t('lblof')} <span>{this.state.pastDrawShow.length}</span> {t('lblentries')}
                        </div>
                        <div class="paginationLRht">
                            <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                            <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                            <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                            <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                        </div>
                    </div>


                </div>
            </>
        )
    }
}


function mapStateToProps(state) {
    const { appvariables } = state.loginReducer;
    return { appvariables };

}
export default connect(mapStateToProps)(withTranslation()(WinnersStory))
